import React, { Fragment } from 'react';
import './../../assets/styles/elements/input-variable.scss';
import { TextInput } from 'evergreen-ui';
import PropTypes from 'prop-types';
import AttributeAPIContainer from './AttributeAPIContainer';
import TitleHolderBuilder from './TitleHolderBuilder';

const InputVariableField = ({
  value,
  onChange,
  placeHolder,
  attributeList,
  showAttribute,
  setShowAttribute,
  handleSelect,
  hasWriteAccess,
}) => {
  return (
    <Fragment>
      <TitleHolderBuilder
        title='Store the value to a variable'
        tooltipInfo='Users Reply will be saved in this variable which you can use later on in bot'
      />
      <div className='variable__input'>
        <AttributeAPIContainer
          attributeList={attributeList}
          showAttribute={showAttribute}
          setShowAttribute={setShowAttribute}
          handleSelect={handleSelect}
        >
          <TextInput
            name='text-input-name'
            placeholder={placeHolder}
            value={value}
            height={40}
            disabled={!hasWriteAccess}
            className='custom-input-style'
            onChange={(e) => {
              onChange(e.target.value);
            }}
          />
        </AttributeAPIContainer>
      </div>
    </Fragment>
  );
};

InputVariableField.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeHolder: PropTypes.string,
  attributeList: PropTypes.arrayOf(PropTypes.string),
  showAttribute: PropTypes.bool,
  setShowAttribute: PropTypes.func,
  handleSelect: PropTypes.func,
  hasWriteAccess: PropTypes.bool,
};
InputVariableField.defaultProps = {
  placeHolder: 'for example: f.name',
  hasWriteAccess: false,
};

export default InputVariableField;
